import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotificacionverde = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 58,
	height: 58,
	viewBox: "0 0 58 58",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "Background_Copy",
			x: 0,
			y: 0,
			width: 58,
			height: 58,
			filterUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("feOffset", {
					dy: 3,
					input: "SourceAlpha"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 3,
					result: "blur"
				}),
				/* @__PURE__ */ _jsx("feFlood", { floodOpacity: .059 }),
				/* @__PURE__ */ _jsx("feComposite", {
					operator: "in",
					in2: "blur"
				}),
				/* @__PURE__ */ _jsx("feComposite", { in: "SourceGraphic" })
			]
		}) }),
		/* @__PURE__ */ _jsx("g", {
			id: "notificacionverde",
			transform: "translate(308.112 3548.156)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Grupo_9311",
				"data-name": "Grupo 9311",
				transform: "translate(-607.112 -3712.156)",
				children: [/* @__PURE__ */ _jsx("g", {
					transform: "matrix(1, 0, 0, 1, 299, 164)",
					filter: "url(#Background_Copy)",
					children: /* @__PURE__ */ _jsx("rect", {
						id: "Background_Copy-2",
						"data-name": "Background  Copy",
						width: 40,
						height: 40,
						rx: 20,
						transform: "translate(9 6)",
						fill: "#5a8217"
					})
				}), /* @__PURE__ */ _jsx("g", {
					id: "notificaciongris",
					transform: "translate(321.333 182)",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Notification",
						transform: "translate(0 0)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Notification-2",
							"data-name": "Notification",
							d: "M6.5,16.13a2.821,2.821,0,0,1-1.882-1.055.568.568,0,0,1,.088-.791.552.552,0,0,1,.782.089,1.708,1.708,0,0,0,1.142.638,1.728,1.728,0,0,0,1.273-.36,1.543,1.543,0,0,0,.287-.281.553.553,0,0,1,.783-.086.568.568,0,0,1,.085.792,2.657,2.657,0,0,1-.482.471A2.82,2.82,0,0,1,6.5,16.13ZM3.241,12.8a3.958,3.958,0,0,1-2.492-1.23A3.278,3.278,0,0,1,0,9.417V9.225A3.307,3.307,0,0,1,.541,7.574L.595,7.5a3.116,3.116,0,0,0,.75-1.47l-.012.049,0-.432.009-.481c.007-.211.019-.4.034-.584a4.83,4.83,0,0,1,1.8-3.273A5.758,5.758,0,0,1,6.835,0h.058a5.764,5.764,0,0,1,3.658,1.313,4.862,4.862,0,0,1,1.807,3.278c.014.16.02.306.023.523v.544c0,.089,0,.168,0,.249l.007.158.036.151a3.148,3.148,0,0,0,.587,1.156l.121.143.05.064a3.264,3.264,0,0,1,.542,1.675v.326a3.281,3.281,0,0,1-.78,2.016,3.865,3.865,0,0,1-2.46,1.2,33.621,33.621,0,0,1-3.628.2A33.592,33.592,0,0,1,3.241,12.8Zm-1.8-4.56h0l-.063.1a2.167,2.167,0,0,0-.253.758l-.014.154V9.43a2.145,2.145,0,0,0,.464,1.385,2.82,2.82,0,0,0,1.775.86,32.665,32.665,0,0,0,3.507.19,32.735,32.735,0,0,0,3.518-.19,2.773,2.773,0,0,0,1.742-.832,2.153,2.153,0,0,0,.495-1.432V9.279a2.086,2.086,0,0,0-.351-1.068l.012.02L12.165,8.1a4.28,4.28,0,0,1-.818-1.612l-.052-.223-.01-.075c-.009-.118-.013-.215-.015-.323l0-.73c0-.184-.007-.308-.017-.442A4.288,4.288,0,0,0,6.893,1.126H6.835A4.272,4.272,0,0,0,2.487,4.689c-.009.1-.016.206-.023.341l-.012.377-.006.742-.012.115A4.247,4.247,0,0,1,1.448,8.23h0Z",
							transform: "translate(0)",
							fill: "#fff"
						})
					})
				})]
			})
		})
	]
});
const ForwardRef = forwardRef(SvgNotificacionverde);
export { ForwardRef as ReactComponent };
